import { countries as allCountries } from './countries';

export function getPhoneFieldCountries(limitAllowedCountries) {
  if (limitAllowedCountries?.enabled && limitAllowedCountries.countries?.length > 0) {
    return allCountries.filter(country => limitAllowedCountries.countries.includes(country.alpha2));
  }
  return allCountries;
}

export function getPhoneFieldDefaultCountry(countries, countryCode) {
  return (
    countries.find(country => country.alpha2 === countryCode)?.alpha2 || countries[0]?.alpha2 || ''
  );
}
